<template>
  <div class="in-passWordChange">
    <!-- <div class="in-changePW flex-center" @click="changePW">
      <i class="el-icon-lock ec-head-icon"></i>
      <p>{{ $t('navbar.changePassword') }}</p>
    </div> -->
    <el-popover
        ref="hover"
        placement="bottom"
        width="200"
        trigger="hover">
      <div slot="reference" class="in-changePW flex-center">
        <el-image
        style="width: 24px; height: 24px"
        :src="require('../../../assets/img/face.png')"></el-image>
        <p style="margin-left:5px">{{userName}}</p>
      </div>
      <el-row  align="middle">
        <el-col class="col-center">
          <el-avatar :size="60" :src="require('../../../assets/img/face.png')"></el-avatar></el-col>
        <el-col class="col-center">{{userName}}</el-col>
        <el-col class="col-center"><div class="iconkey" @click="changePW"><i class="el-icon-key"></i></div></el-col>
        <el-col class="col-center"><el-divider></el-divider></el-col>
        <el-col class="col-left">
          <i class="el-icon-postcard"></i>
          <p class="p-size">{{roleNames}}</p></el-col>
        <el-col class="col-left">
          <i class="el-icon-office-building"></i>
          <p class="p-size">{{orgName}}</p></el-col>
      </el-row>
    </el-popover>
    <el-dialog
      v-dialogDrag
      width="380px"
      :title="this.$t('table.changePassword')"
      class="dialog--mini"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        ref="editForm"
        :inline="true"
        :model="filters"
        label-width="80px"
        :rules="editFormRules"
      >
        <el-col :span="24">
          <el-form-item :label="this.$t('table.oldPassword')" prop="oldPwd">
            <el-input v-model="filters.oldPwd" type="password" auto-complete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="this.$t('table.newPassword')" prop="firstPasswd">
            <el-input v-model="filters.firstPasswd" type="password" auto-complete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="this.$t('table.password')" prop="passwd">
            <el-input v-model="filters.passwd" type="password" auto-complete="off" />
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="editFormVisible=false">{{ this.$t('button.cancel') }}</el-button>
        <el-button
          v-preventReClick
          size="small"
          type="primary"
          @click="submitPassword"
        >{{ this.$t('button.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var checkPasswd = (rule, value, callback) => {
      let _this = this
      if (value === '' || typeof value === 'undefined') {
        return callback(new Error(_this.$t('errorLog.enterPassword')))
      } else {
        let model = _this.$refs.editForm.model
        if (model.passwd !== '') {
          _this.$refs.editForm.validateField('passwd')
        }
        callback()
      }
    }
    var checkPasswd2 = (rule, value, callback) => {
      let _this = this
      if (value === '' || typeof value === 'undefined') {
        return callback(new Error(_this.$t('errorLog.enterPassword')))
      } else {
        let model = _this.$refs.editForm.model
        if (model.passwd === model.firstPasswd) {
          callback()
        } else {
          let err = _this.$t('errorLog.passwordinConsistent')
          callback(new Error(err))
        }
      }
    }

    return {
      name: 'EcHeaderPw',
      roleNames:"",
      userName:"",
      orgName:"",
      editFormVisible: false,
      filters: {
        oldPwd: '',
        firstPasswd: '',
        passwd: ''
      },
      editFormRules: {
        oldPwd: [
          {
            required: true,
            message: this.$t('errorLog.enterPassword'),
            trigger: 'blur'
          }
        ],
        firstPasswd: [
          {
            required: true,
            message: this.$t('errorLog.enterPassword'),
            validator: checkPasswd,
            trigger: 'blur'
          }
        ],
        passwd: [
          {
            required: true,
            validator: checkPasswd2,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  inject: ['UpdateLogout'],
  created(){
    this.roleNames = this.$store.state.roleNames.toString()
    this.userName = this.$store.state.userName.toString()
    this.orgName = this.$store.state.orgName.toString()
  },
  methods: {
    changePW() {
      const _this = this
      _this.filters = {}
      _this.editFormVisible = true
    },
    submitPassword() {
      let _this = this
      let model = _this.$refs.editForm.model
      _this.$refs.editForm.validate(async valid => {
        if (valid) {
          let params = { oldPwd: model.oldPwd, passwd: model.passwd }
          const { success, message } = await _this.Api.modifyPwd(params);
          if(success) {
            _this.$message({
              showClose: true,
              message: '密码修改成功,请重新登陆',
              type: 'success'
            })
            _this.UpdateLogout(true)
          } else {
            _this.$message({
              showClose: true,
              message: message || '提交失败，请重新提交',
              type: 'error'
            })
          }
        }
      })
    }
  }
}
</script>

<style>
  .col-center{
    display:flex;
    justify-content:center;/*主轴上居中*/
    align-items:center;/*侧轴上居中*/
    margin-top: 5px;
  }
  .col-left{
    display:flex;
    justify-content:left;/*主轴上居中*/
    align-items:center;/*侧轴上居中*/
    margin-top: 5px;
    font-size: 15px;
  }
  .p-size{
    font-size: 10px;
    margin-left: 5px;
  }
  .el-divider{
    margin: 0 0;
    border-top: 1px solid;
  }
  .iconkey{
    border-radius:50%;
    background-color:rgb(236, 229, 229);
  }
  .el-icon-key:hover{
    color:blue;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/EcHeaderPw.vue